module.exports = __webpack_public_path__ + "img/angle-up.9bf7fd0a.svg";